import { Account } from '../operations/account';
import { Currency } from '../operations/currency';
import { User } from './user';

export class Preferences {
  private _user: User;
  private _currency: Currency;
  private _mainAccount: Account;
  private _echeanceDelay: number;
  private _pointEcheance: boolean;
  private _modeAutoImport: string | null; // Allow null values
  private _simpleMode: boolean;
  private _sortByDate: boolean;
  private _sortedCategoryIds: string;
  private _usageName: string;
  private _language: string;

  constructor(
    user: User,
    currency: Currency,
    mainAccount: Account,
    echeanceDelay: number,
    pointEcheance: boolean,
    modeAutoImport: string | null, // Allow null values
    simpleMode: boolean,
    sortByDate: boolean,
    sortedCategoryIds: string,
    usageName: string,
    language: string
  ) {
    this._user = user;
    this._currency = currency;
    this._mainAccount = mainAccount;
    this._echeanceDelay = echeanceDelay;
    this._pointEcheance = pointEcheance;
    this._modeAutoImport = modeAutoImport;
    this._simpleMode = simpleMode;
    this._sortByDate = sortByDate;
    this._sortedCategoryIds = sortedCategoryIds;
    this._usageName = usageName;
    this._language = language;
  }

  get user(): User { return this._user; }
  set user(user: User) { this._user = user; }

  get currency(): Currency { return this._currency; }
  set currency(currency: Currency) { this._currency = currency; }

  get mainAccount(): Account { return this._mainAccount; }
  set mainAccount(mainAccount: Account) { this._mainAccount = mainAccount; }

  get echeanceDelay(): number { return this._echeanceDelay; }
  set echeanceDelay(echeanceDelay: number) { this._echeanceDelay = echeanceDelay; }

  get pointEcheance(): boolean { return this._pointEcheance; }
  set pointEcheance(pointEcheance: boolean) { this._pointEcheance = pointEcheance; }

  get modeAutoImport(): string | null { return this._modeAutoImport; }
  set modeAutoImport(modeAutoImport: string | null) { this._modeAutoImport = modeAutoImport; }

  get simpleMode(): boolean { return this._simpleMode; }
  set simpleMode(simpleMode: boolean) { this._simpleMode = simpleMode; }

  get sortByDate(): boolean { return this._sortByDate; }
  set sortByDate(sortByDate: boolean) { this._sortByDate = sortByDate; }

  get sortedCategoryIds(): string { return this._sortedCategoryIds; }
  set sortedCategoryIds(sortedCategoryIds: string) { this._sortedCategoryIds = sortedCategoryIds; }

  get usageName(): string { return this._usageName; }
  set usageName(usageName: string) { this._usageName = usageName; }

  get language(): string { return this._language; }
  set language(language: string) { this._language = language; }

  public updateMainAccount(newAccount: Account): void {
    this._mainAccount = newAccount;
  }
}